import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";

/**
 * @param {String} code Location code
 * @param {String} name Location name
 * @returns {String} Joined string with <Location code> - <location name>
 */
export const joinLocation = (code, name = "") => `${code} - ${name}`;

/**
 * @param {string|undefined} location Location code and name formatted with " - " in between.
 * @returns {[string, string]} The location code and the location name
 */
export function splitLocation(location) {
  const matches = (location || "").match(/(.+?) - (.+)/);
  if (!matches) return [location || "", ""];
  return matches.slice(1, 3).map((a) => (a || "").trim());
}

export async function fetchAllSalesLocations(fullId) {
  const url = `${TASKS_SERVICE_URL}/v1/locations/defined?full_id=${fullId}`;

  const { result } = await fetchAPI("GET", url);
  return result?.data?.list || [];
}

export function nonSLMFoodLocation(isFoodArticle, hasNoSLMLocations) {
  const sfmLocationList = [];
  if (isFoodArticle && hasNoSLMLocations) {
    const frontendFriendlyObject = {
      location: "SFM",
      locationDescription: "Swedish Food Market",
      department: "",
      isPrimary: true,
      isHomeBase: true,
    };
    sfmLocationList.push(frontendFriendlyObject);
  }
  return { sfmLocationList };
}

export function productQualityLocations(isProductQualityTask) {
  const productQualityLocationsList = [];
  if (isProductQualityTask) {
    const productQualityAreaObject = {
      code: "Quality Area/Cage",
      locationDescription: "",
      department: "",
      isPrimary: false,
      isHomeBase: false,
      section: "Quality Area/Cage",
    };
    const productQualityCageObject = {
      code: "Recovery",
      locationDescription: "",
      department: "",
      isPrimary: false,
      isHomeBase: false,
      section: "Recovery",
    };
    productQualityLocationsList.push(
      productQualityAreaObject,
      productQualityCageObject
    );
  }
  return { productQualityLocationsList };
}

export async function getAllLocationsFromSLM() {
  const url = `${TASKS_SERVICE_URL}/v1/locations/store`;
  const { result } = await fetchAPI("GET", url);
  return result;
}
